export default __webpack_public_path__ + "static/tag-do-5-light-e1d5ff68bb2f075556edfbb0555f58ebaea47ac1c82c66641d00dc2d290aa1aa.png";